import {HttpCustomService} from "../../service/http-custom.service";
import {AbstractControl, AsyncValidatorFn} from "@angular/forms";
import {Observable, of} from "rxjs";
import {API} from "../apis/api";
import {take} from "rxjs/operators";
import * as _ from "lodash";

export function checkUniqueStationCode(http: HttpCustomService): AsyncValidatorFn {
  return (control: AbstractControl): Observable<{[key: string]: any}> | null => {
    if (control) {
      const stationCode = control.value;
      const cooperativeNo = control.parent.get('cooperativeNo').value;
      const stationNo = control.parent.get('stationNo').value;
      http.get({path: API.STATION_CODE_UNIQUE_CHECK}, {'station-code': stationCode, 'cooperative-no': cooperativeNo || '', 'station-no': stationNo || ''})
        .pipe(take(1))
        .subscribe(data => {
          if (!_.isNull(data) && data) {
            control.setErrors({existedStationCode: data});
          }
        });
      return of(null);
    }
  }
}
